export interface StorytellerData {
    plaqueData: StorytellerPlaqueData;
    itemData?: StorytellerItemData;
    communityData: StorytellerCommunityData;
    storyData: StorytellerStoryData;
  }
  
  export interface StorytellerPlaqueData {
    id: number;
    uniqueId: string;
    name: string;
    isShowPlaqueDetails: boolean;
    plaqueTypeId: number;
    accessLevel: number;
  }
  
  export interface StorytellerItemData {
    id: number;
    uniqueId: string;
    name: string;
    galleryBlob: string;
    isPosted: boolean;
    statusId: number;
    campaignTypeId: number;
  }
  
  export interface StorytellerCommunityData {
    id: number;
    name: string;
    address: string;
    profileBlob: string;
  }

  export interface StorytellerStoryData {
    name: string;
    description: string;
    coverImages: string;
    pages: StorytellerStoryPageData[];
  }
  
  export interface StorytellerStoryPageData {
    image: string;
  }